/// <amd-module name="VSSUI/Status" />
export { Status, StatusType, Statuses } from "./Components/Status/Status";
export { IStatusProps, StatusSize } from "./Components/Status/Status.Props";
